module.exports = "<h4>{{title}}</h4>\r\n\r\n<div style=\"display:block\">\r\n  <canvas baseChart [datasets]=\"barChartData\" [labels]=\"barChartLabels\" chartType=\"bar\"></canvas>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/components/graphic-bar/graphic-bar.component.html
// module id = ../../../../../src/app/components/graphic-bar/graphic-bar.component.html
// module chunks = main